var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayInfoIcon = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00521 0.667969C4.40521 0.667969 0.671875 4.4013 0.671875 9.0013C0.671875 13.6013 4.40521 17.3346 9.00521 17.3346C13.6052 17.3346 17.3385 13.6013 17.3385 9.0013C17.3385 4.4013 13.6052 0.667969 9.00521 0.667969ZM9.83854 13.168H8.17188V8.16797H9.83854V13.168ZM9.83854 6.5013H8.17188V4.83464H9.83854V6.5013Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/grayInfoIcon.4d881662b8a631312ed889a7f2f10ce4.svg";